import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';

import { Layout } from '@components/atoms';
import { routePath } from '@constants/path';
import RequireAuthRoute from '@routes/RequireAuthRoute';
import RoutesLayout from '@routes/RoutesLayout';
import GlobalStyle from '@styles/global-styles';
import Amplify from 'aws-amplify';

import awsExports from '../../aws-exports';
import MBTIRegisterPage from './MBTIRegisterPage';

Amplify.configure(awsExports);

function App(): ReactElement {
  return (
    <>
      <GlobalStyle />
      <Switch>
        {/* PC 등록 페이지: 모바일 480px 레이아웃 우회 */}
        <Route component={MBTIRegisterPage} exact path={routePath.mbtiRegister.path} />
        {/* 그 외 라우트: 기존 모바일 레이아웃 */}
        <Route
          render={() => (
            <Layout>
              <Layout>
                <Switch>
                  <RequireAuthRoute component={RoutesLayout} />
                </Switch>
              </Layout>
            </Layout>
          )}
        />
      </Switch>
    </>
  );
}

export default App;
